export const DEVICE_ISSUES = {
  WL01: 'Offline',
  WL02: 'Weak signal strength', // 'moveClientCloser'
  WL04: 'Weak signal strength', // 'moveClientCloser'
  WDT1: 'Slow speeds', // 'runRealSpeedTest'
  WL03: 'Good connection', // 'changeBand'
  WPL01: 'Offline', // 'checkPowerOrPlugin'
  WPL02: 'Good connection', // 'relocatePod'
  WPL03: 'Good connection', // 'rebootPod'
  WPL04: 'Good connection', // 'returnPod'
  WPL05: 'Good connection', // 'changePodConfiguration'
  WRH01: 'Good connection', // 'connectToEthernet'
  WCL00: 'Good connection', // 'noFurtherStepsRequired'
};
